import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";
import {CachedFile} from "../model/cached-files/CachedFile";

@Injectable({
  providedIn: 'root'
})
export class CachedFilesService {

  private readonly serviceUrl = '/cached-files';

  constructor(private http: HttpClient) {
  }

  public getCachedFilesList(): Observable<CachedFile[]> {
    return this.http.get<CachedFile[]>(environment.apiUrl + this.serviceUrl);
  }

  public deleteFile(file: CachedFile): Observable<any> {
    return this.http.delete<any>(environment.apiUrl + this.serviceUrl, {body: file});
  }

  public deleteAllFile(): Observable<any> {
    return this.http.delete<any>(environment.apiUrl + this.serviceUrl + '/all');
  }
}
